import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { savedLocationsApiSchema } from '../../models';

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

export type SavedLocationsRequestParams = {
  CustomerKey: number;
  PageSize?: number;
  PageNumber?: number;
  SearchValue: string;
};

const shipmentApi = fetcher.extend(() => ({ prefixUrl: `${API.SHIPMENT}` }));

export const fetchSavedLocations = async (
  filters: SavedLocationsRequestParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await shipmentApi
      .get('GetLocationSearch', {
        searchParams: {
          ...filters,
          PageNumber: filters.PageNumber ?? DEFAULT_PAGE_NUMBER,
          PageSize: filters.PageSize ?? DEFAULT_PAGE_SIZE,
        },
        signal,
      })
      .json(savedLocationsApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on locations search response',
        (error as ValiError<typeof savedLocationsApiSchema>).issues,
      );
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
